let hostVal = window.location.host
let protocol = window.location.protocol
let hostUrlFilter = () => {
  // 环境域名
  let hostUrl = `${protocol}//${hostVal}`
  return hostUrl
}
let cuttingFiler = () => {
  let shopId = window.location.pathname.split('/')[1]
  let prefix = '/' + shopId
  return prefix
}
export default {
  hostUrlFilter,
  cuttingFiler
}
